<div
  class="d-flex justify-content-center align-items-center flex-column session-timeout-placeholder">
  <img class="py-5" src="assets/svg/icon-logout.svg" alt="timeout icon" />
  <h1 class="text-center">Your session has timed out.</h1>
</div>
